/** @format */

import React from "react";
import PlansPricingLanding from "./components/PlansPricingLanding/PlansPricingLanding";

import styles from "./LandingPage.module.scss";

export default function LandingPage() {
	return (
		<article className={styles.container}>
			<PlansPricingLanding />
		</article>
	);
}
